import React from 'react'
import { Box, Display, FlexDirection } from '@gousto-internal/citrus-react'

import type { CategoryGridContentBlock } from '@library/api-menu-experience'
import type { CollectionSlug, CollectionUUID } from '@library/menu-service'

import { ParentCategory } from '../ParentCategory/ParentCategory'

export type CategoryGridProps = {
  contentBlock: CategoryGridContentBlock
  onCategoryClick: (categoryId: string, slug: string, parentCategoryId?: string) => void
}

const toCollectionId = (id: string) => id as CollectionUUID
const toCollectionSlug = (slug: string) => slug as CollectionSlug

export const CategoryGrid = ({ contentBlock, onCategoryClick }: CategoryGridProps) => (
  <Box display={Display.Flex} flexDirection={FlexDirection.Column} gap={10}>
    {contentBlock.parentCategories.map((parentCategory) => (
      <ParentCategory
        key={parentCategory.id}
        id={toCollectionId(parentCategory.id)}
        slug={toCollectionSlug(parentCategory.slug)}
        name={parentCategory.title ?? parentCategory.slug}
        description={parentCategory.description}
        isLinkable={parentCategory.isLinkable}
        type={parentCategory.type}
        recipeCount={parentCategory.recipeCount ?? 0}
        categories={parentCategory.categories.map((category) => ({
          id: toCollectionId(category.id),
          slug: toCollectionSlug(category.slug),
          shortTitle: category.title,
          recipeCount: category.recipeCount,
          image: category.image && {
            crops: category.image.crops,
            type: category.image.type!,
          },
        }))}
        onCategoryClick={onCategoryClick}
      />
    ))}
  </Box>
)
